import { useState } from "react";
import MobileMenu from "../../sections/mobileMenu/mobileMenu";
import Header from "../../sections/header/header";
import ReviewBonus from "../../sections/reviewBonus/reviewBonus";
import Footer from "../../sections/footer/footer";
import PopupForm from "../../sections/popupForm/popupForm";
import CallbackForm from "../../sections/callbackForm/callbackForm";

const Bonus = () => {
  const [message, setMessage] = useState("");

  return (
    <>
      <MobileMenu />
      <div className="page page--index page--cabinet">
        <Header />
        <main className="page__main">
          <ReviewBonus message={message} setMessage={setMessage} />
        </main>
        <Footer />
        <PopupForm setMessage={setMessage} />
        <CallbackForm />
      </div>
    </>
  );
};

export default Bonus;
